var _rect, _path, _path2, _rect2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "71px",
    viewBox: "0 0 69 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0B33348B-589F-4F27-9632-A3FD64C97227") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Secondary-Navigation-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support-Select-Copy",
    transform: "translate(-402.000000, -1234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Computer",
    transform: "translate(402.000000, 1234.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EB0504",
    fillRule: "nonzero",
    x: 27.0681818,
    y: 51.95,
    width: 14.7727273,
    height: 13.2954545
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.9090909,43.5636364 L-4.12114787e-13,43.5636364 L-4.12114787e-13,3.2974026 C-4.12114787e-13,1.59383117 1.29204545,0.2 2.87121212,0.2 L66.0378788,0.2 C67.6170455,0.2 68.9090909,1.59383117 68.9090909,3.2974026 L68.9090909,43.5636364 Z",
    id: "Path",
    fill: "#DBE2EA",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9090909,43.5636364 L0,43.5636364 L0,49.4727273 C0,51.0977273 1.29204545,52.4272727 2.87121212,52.4272727 L66.0378788,52.4272727 C67.6170455,52.4272727 68.9090909,51.0977273 68.9090909,49.4727273 L68.9090909,43.5636364 Z",
    id: "Path",
    fill: "#FF5756",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.75,63.7681818 L21.1590909,63.7681818 C19.5340909,63.7681818 18.2045455,65.0977273 18.2045455,66.7227273 L18.2045455,70.2 L50.7045455,70.2 L50.7045455,66.7227273 C50.7045455,65.0977273 49.375,63.7681818 47.75,63.7681818 Z",
    id: "Path",
    fill: "#FF5756",
    fillRule: "nonzero"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 20.4545455,
    y: 8.2,
    width: 28,
    height: 28,
    rx: 14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero",
    points: "39.2162192 17.0712309 42.0509019 19.9059136 32.8855845 29.0712309 26.8581891 23.299175 29.6634991 20.4354211 32.8566787 23.4306269"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.789147adc37c6fba3059fdce2278ea2e.svg";
export { ForwardRef as ReactComponent };